/**
 * When multiple EPR grading profiles exist for a year, the PDF service expects the
 * latest semester's profile id for a full-year style PDF. Picks that DTO from the
 * `eprGradingProfileRead` payload.
 *
 * @param {object[]|null|undefined} payload
 * @returns {object|null}
 */
export const pickEprForMostRecentPdf = (payload) => {
    const list = payload?.filter(Boolean) ?? [];
    if (!list.length) {
        return null;
    }
    if (list.length === 1) {
        return list[0];
    }
    //rank by extracting first digit from semester label
    // if no digit, use second or first keyword
    // otherwise return 0, unknown rank
    const rank = (epr) => {
        const s = String(epr?.semester ?? "").toLowerCase();
        const digit = /(\d)/.exec(s);
        if (digit) {
            return Number.parseInt(digit[1], 10);
        }
        if (s.includes("second") || s.includes("2nd")) {
            return 2;
        }
        if (s.includes("first") || s.includes("1st")) {
            return 1;
        }
        return 0;
    };
    const sorted = [...list].sort((a, b) => rank(a) - rank(b));
    return sorted.at(-1); // return the most recent semester
};

/**
 * Index of the EPR in `eprs` that {@link pickEprForMostRecentPdf} would choose (same semester ranking).
 * Used so guardian UI defaults to the most recent semester.
 *
 * @param {object[]|null|undefined} eprs
 * @returns {number}
 */
export const indexOfEprForMostRecentPdf = (eprs) => {
    const picked = pickEprForMostRecentPdf(eprs);
    if (!picked) {
        return 0;
    }
    const idx = eprs == null ? -1 : eprs.indexOf(picked);
    return Math.max(idx, 0);
};
